import type { ValueFormat } from '../../api/managementReports';

/** How a report value is shown: thousands separators, "12.5%", "$1,234.50", "3 Oct 2026"; "—" when there is nothing to divide by. */
export const formatValue = (value: number | string | null | undefined, format?: ValueFormat | 'date') => {
  if (value === null || value === undefined || value === '') return format && format !== 'date' ? '—' : '';
  if (format === 'percent') return `${value}%`;
  if (format === 'currency' && typeof value === 'number')
    return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  if (format === 'number' && typeof value === 'number') return value.toLocaleString('en-GB');
  if (format === 'date' && typeof value === 'string')
    return new Date(`${value}T00:00:00Z`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
  return String(value);
};
